const apiUrl = 'https://applynowapi.hippomotorgroup.com/';const apiSecret = 'GQ9URbsvcLWrpYXhJzmnMpZtbPeksaKBS36dBNRNNNYKHMdUAV';export {apiUrl,apiSecret}
